"use client";
import { useTranslation } from "@/hooks/localization/useTranslations";
import React from "react";

const StockAlertMessage: React.FC<{ minStockQuantity: number }> = ({
  minStockQuantity,
}) => {
  const t = useTranslation();
  return (
    <div className="stock-alert-message">{`${t.only} ${minStockQuantity} ${t.pieces_available}`}</div>
  );
};

export default StockAlertMessage;
